<template>
  <div id="home">
    <div  class="page flex-col">

      <div class="block_19 flex-col">
        <article class="swiperBox">
          <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide>
              <div class="swiperImage banner1"></div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiperImage banner2"></div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiperImage banner3"></div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="icon-zuo-yuan iconfont" slot="button-prev"></div>
            <div class="icon-you-yuan iconfont" slot="button-next"></div>
          </swiper>
        </article>
        <div class="box_88 flex-col">

          <div class="group_71 flex-row justify-between">
            <div class="group_6 flex-col">
              <div class="text-group_79 flex-col justify-between">
                <span class="text_9">新闻热点</span>
                <span class="text_10">安讯新闻热点集锦</span>
              </div>
              <div class="text-wrapper_1 flex-col" @click="navtonewindex">
                <span class="text_11">立即查看</span>
              </div>
            </div>
            <div class="box_49 flex-col justify-between"  @click="goDetials(newsList[0])">
              <div class="group_8 flex-row justify-between">
                <div class="text-group_80 flex-col justify-between">
                  <span class="text_12">{{newsList[0].title}}</span>
                  <span class="text_13">{{newsList[0].createTime}}</span>
                </div>
                <img
                  class="image_3"
                  referrerpolicy="no-referrer"
                  :src="newsList[0].blogPic"
                />
              </div>
              <div class="group_94 flex-row justify-between" @click="goDetials(newsList[1])">
                <div class="text-group_81 flex-col justify-between">
                  <span class="text_14">{{newsList[1].title}}</span>
                  <span class="text_15">{{newsList[1].createTime}}</span>
                </div>
                <img
                  class="image_4"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGa673e37a3378241a760d5efc6e2b1202.png"
                />
              </div>
            </div>
            <div class="group_10 flex-col">
              <div class="image-text_64 flex-row justify-between" @click="goDetials(newsList[2])">
                <div class="text-group_82 flex-col justify-between">
                  <span class="text_16">{{newsList[2].title}}</span>
                  <span class="text_17">{{newsList[2].createTime}}</span>
                </div>
                <!-- <img
                  class="image_5"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG4c2bf8ecaafa6d9e428c39eec1d2764f.png"
                /> -->
              </div>
              <div class="text-group_83 flex-col justify-between" @click="goDetials(newsList[3])">
            <span class="text_18"
            >{{newsList[3].title}}</span
            >
                <span class="text_19">{{newsList[3].createTime}}</span>
              </div>
              <div class="text-group_84 flex-col justify-between" @click="goDetials(newsList[4])">
                <span class="text_20">{{newsList[4].title}}</span>
                <span class="text_21">{{newsList[4].createTime}}</span>
              </div>
            </div>
          </div>
          <div class="text-group_85 flex-col justify-between">
            <span class="text_22">丰富成熟专业的解决方案</span>
            <span class="text_23"
            >安讯将竭诚为您提供可定制化消防系统整体解决方案</span
            >
          </div>

          <img
            class="image_25"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG45b6cf92df22ab4eec751d4b352c86b5.png"
          />
          <div class="group_72 flex-row justify-between">
            <div class="text-group_86 flex-col justify-between">
              <span class="text_24">安讯产品中心</span>
              <span class="text_25">安讯将竭诚为您提供消防全产业链服务</span>
            </div>
            <!-- <div class="block_1 flex-col"></div> -->
          </div>
          <div class="group_73 flex-row justify-between">
            <div class="box_33 flex-col">
              <div class="box_50 flex-row justify-between" @click="goOther('contentUnion')">
                <span class="text_26">硬件产品</span>
                <img
                  class="thumbnail_7"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGc743f0a07f724f6d874a64756e7e8663.png"
                />
              </div>
              <span class="text_27">无线烟雾报警器</span>
            </div>
            <div class="box_44 flex-col">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGa31d3a8b16c7f76217056ff5246e2d6b.png"
              />
              <span class="text_28">物联网空气开关</span>
              <span class="text_29">能够探测火灾时产生的大量烟雾</span>
            </div>
            <div class="box_55 flex-col">
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG8c41f101bbc68255ed571416d98895c5.png"
              />
              <span class="text_30">智慧用电管理终端</span>
              <span class="text_31"
              >提前预警发出信号&nbsp;&nbsp;&nbsp;&nbsp;防患于未然</span
              >
            </div>
            <div class="box_66 flex-col">
              <div class="image-text_65 flex-col justify-between">
                <img
                  class="image_8"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGcc2057cf37d31329b1b43178930c13d1.png"
                />
                <span class="text-group_9">用户信息传输装置</span>
              </div>
              <span class="paragraph_1"
              >对分散的消防控制器及用户消防<br />设施进行集中监控</span
              >
            </div>
            <div class="box_77 flex-col">
              <img
                class="image_9"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG27dabfe92468c2b5dc7eb7fbde52988e.png"
              />
              <span class="text_32">无线一氧化碳报警器</span>
              <span class="text_33">检测一氧化碳浓度，提前告警</span>
            </div>
          </div>
          <div class="group_74 flex-row justify-between">
            <div class="block_2 flex-row">
              <div class="text-group_87 flex-col justify-between">
                <span class="text_34">无线燃气报警器</span>
                <span class="text_35">采用高品质气敏元件</span>
              </div>
            </div>
            <div class="block_3 flex-col">
              <img
                class="image_10"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGfba41ac1e61bfb0689fc354e474e0ada.png"
              />
              <span class="text_36">智能无线压力变送器</span>
              <span class="text_37">实现仪表数据到服务器的无线传输</span>
            </div>
            <div class="block_4 flex-col">
              <img
                class="image_11"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGd0424b61ec65dfdb5112a4ccbfe8a43c.png"
              />
              <span class="text_38">智能无线液位变送器</span>
              <span class="text_39">一款高精度、高稳定性的智能化无线测量产品</span>
            </div>
            <div class="block_5 flex-col">
              <img
                class="image_12"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG051650f992762742140b2aeea4aea663.png"
              />
              <span class="text_40">智能手动报警器</span>
              <span class="text_41"
              >手动无线报警器&nbsp;&nbsp;监测中心可收到报警做出响应</span
              >
            </div>
            <div class="block_6 flex-col">
              <div class="image-text_66 flex-col justify-between">
                <img
                  class="image_13"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG1fa514d1de43f6459b9724fcf042cb04.png"
                />
                <span class="text-group_11">智能消防栓</span>
              </div>
              <span class="text_42">智能闷盖&nbsp;&nbsp;实现消防栓的智能管理</span>
            </div>
          </div>
          <div class="group_15 flex-col">
            <div class="group_16 flex-col">
              <span class="text_43">多种系统解决方案</span>
              <span class="paragraph_2"
              >以物联网为基础，提供消防数据交换<br />服务的提供商</span
              >

              <div v-if="type==1"  class="text-wrapper_2 flex-col">
              <span  class="text_44"  @click="save(1)">云上平台</span>
              </div>
              <span v-if="type!==1"  class="text_45" @click="save(1)">云上平台</span>


              <div v-if="type==2"  class="text-wrapper_2 flex-col">
              <span  class="text_44"  @click="save(1)">智慧消防</span>
              </div>
              <span v-if="type!==2"  class="text_45" @click="save(2)">智慧消防</span>


              <div v-if="type==3"   class="text-wrapper_2 flex-col">
              <span  class="text_44"  @click="save(1)">智慧维保</span>
              </div>
              <span v-if="type!==3"   class="text_46" @click="save(3)">智慧维保</span>


              <div v-if="type==4"   class="text-wrapper_2 flex-col">
              <span  class="text_44"  @click="save(1)">应急指挥</span>
              </div>
              <span v-if="type!==4"  class="text_47" @click="save(4)">应急指挥</span>


              <div  v-if="type==5"  class="text-wrapper_2 flex-col">
              <span  class="text_44"  @click="save(1)">智慧社区</span>
              </div>
              <span v-if="type!==5"  class="text_48" @click="save(5)">智慧社区</span>



              <div v-if="type ==1" class="box_39 flex-col">

                  <img  src="../../assets/images/home/ypt.png">

              </div>
              <div v-if="type ==2" class="box_39 flex-col">

                  <img src="../../assets/images/home/wlpt.png">

              </div>
              <div v-if="type ==3" class="box_39 flex-col">

                  <img src="../../assets/images/home/zhwb.png">

              </div>
              <div v-if="type ==4" class="box_39 flex-col">

                  <img src="../../assets/images/home/zh.png">

              </div>
              <div v-if="type ==5" class="box_39 flex-col">

                  <img  src="../../assets/images/home/sq.png">

              </div>
            </div>
          </div>
             <div class="group_17 flex-col">
      <span class="text_51">经典案例</span>
      <div class="box_9 flex-col">
        <div class="text-wrapper_82 flex-row">
          <span class="text_52"
            >安讯将竭诚为您提供可定制化消防系统整体解决方案</span
          >
        </div>
        <div class="box_51 flex-row">
          <div class="image-text_67 flex-col justify-between">
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGc696bc56eaca32a201b0462d9785958c.png"
            />
            <span class="text-group_12">广西妇产医院</span>
          </div>
          <div class="block_25 flex-col justify-between">
            <div class="image-text_68 flex-col justify-between">
              <img
                class="image_16"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG488889d7859140a365dd1f222185e7f0.png"
              />
              <span class="text-group_13">柳州中医院</span>
            </div>
            <div class="image-text_69 flex-col justify-between">
              <img
                class="image_17"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGd3dfc741be69499a6d1aaac8c1783e6d.png"
              />
              <span class="text-group_14">中国人民保险PICC</span>
            </div>
          </div>
          <div class="box_12 flex-col">
            <span class="text_53">众多合作案例</span>
            <div class="image-text_70 flex-row justify-between" @click="goOther('projectCase')">
              <span class="text-group_15">查看更多</span>
              <img
                class="thumbnail_8"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGceaab62dc89c96f34136aea194463ce1.png"
              />
            </div>
          </div>
          <div class="block_26 flex-col justify-between">
            <img
              class="image_18"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG1d524ba5c61f3b013c55472d405be01d.png"
            />
            <div class="group_75 flex-row justify-between">
              <div class="group_76 flex-col justify-between">
                <span class="text_54">海城区人民法院</span>
                <div class="image-text_71 flex-col justify-between">
                  <img
                    class="image_19"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG5e5a1b0d3a76209a65819a28c27fced9.png"
                  />
                  <span class="text-group_16">北海北部湾一号</span>
                </div>
              </div>
              <div class="group_77 flex-col justify-between">
                <img
                  class="image_20"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGfa7943b46a68de5bfb945d0e9cdd23b3.png"
                />
                <span class="text_55">沃美酒店</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box_52 flex-col">
      <div class="box_14 flex-col">
        <div class="section_30 flex-row">
          <div class="text-group_88 flex-col justify-between">
            <span class="text_56">资质证书</span>
            <span class="text_57"
              >安讯将竭诚为您提供可定制化消防系统整体解决方案</span
            >
          </div>
        </div>
        <div class="text-wrapper_83 flex-row justify-between">
          <span class="text_58">软件著作</span>
          <span class="text_59">实用新型</span>
          <span class="text_60">发明专利</span>
          <span class="text_61">集成电路专利</span>
        </div>
        <div class="text-wrapper_84 flex-row">
          <span class="text_62">39+</span> <span class="text_63">6+</span>
          <span class="text_64">2+</span> <span class="text_65">1+</span>
        </div>
      </div>
      <article class="certificate">
          <aside class="commonTop">

            <div class="explain">

            </div>
          </aside>
          <section class="certificateBox" id="certify">
            <swiper :options="certifySwiperOption" ref="certifySwiperOption">
              <!-- slides -->
              <swiper-slide>
                <div class="swiperImage">
                  <div class="slideTop">
                    <div class="flt">
                      <div class="imgBox certificate1"></div>
                    </div>
                    <div class="frt">
                      <p class="text">信息系统集成</p>
                      <div>资质证书</div>
                    </div>
                  </div>
                  <div class="slideTitle">信息系统集成资质证书</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiperImage">
                  <div class="slideTop">
                    <div class="flt">
                      <div class="imgBox certificate2"></div>
                    </div>
                    <div class="frt">
                      <p class="text">建筑业企业</p>
                      <div>资质证书</div>
                    </div>
                  </div>
                  <div class="slideTitle">建筑业企业资质证书</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiperImage">
                  <div class="slideTop">
                    <div class="flt">
                      <div class="imgBox certificate3"></div>
                    </div>
                    <div class="frt">
                      <p class="text">安讯消防维护管理平台</p>
                      <div>软件著作权证书</div>
                    </div>
                  </div>
                  <div class="slideTitle">安讯消防维护管理平台软件著作权证书</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiperImage">
                  <div class="slideTop">
                    <div class="flt">
                      <div class="imgBox certificate4"></div>
                    </div>
                    <div class="frt">
                      <p class="text">安讯工程企业设计施工</p>
                      <div>维护能力证书</div>
                    </div>
                  </div>
                  <div class="slideTitle">安讯工程企业设计施工维护能力证书</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiperImage">
                  <div class="slideTop">
                    <div class="flt">
                      <div class="imgBox certificate5"></div>
                    </div>
                    <div class="frt">
                      <p class="text">建筑业企业</p>
                      <div>资质证书</div>
                    </div>
                  </div>
                  <div class="slideTitle">建筑业企业资质证书</div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiperImage">
                  <div class="slideTop">
                    <div class="flt">
                      <div class="imgBox certificate6"></div>
                    </div>
                    <div class="frt">
                      <p class="text">工程设计与施工</p>
                      <div>资质证书</div>
                    </div>
                  </div>
                  <div class="slideTitle">工程设计与施工资质证书</div>
                </div>
              </swiper-slide>
              <!-- Optional controls -->
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="icon-zuo-yuan iconfont" slot="button-prev"></div>
              <div class="icon-you-yuan iconfont" slot="button-next"></div>
            </swiper>
          </section>
        </article>
    </div>
        </div>

      </div>
      </div>
    </div>

</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
export default {
  name: "home",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      type:1,
      newsList:[],
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".icon-you-yuan",
          prevEl: ".icon-zuo-yuan"
        }
      },

      certifySwiperOption: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
          nextEl: ".icon-you-yuan",
          prevEl: ".icon-zuo-yuan"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {

          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              let translate = slideProgress * modify * 260 + "px";
              let scale = 1 - Math.abs(slideProgress) / 5;
              let zIndex = 999 - Math.abs(Math.round(50 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      }
    };
  },
mounted() {
    this.getNewsList();
    // window.location.reload();
  },
  methods: {
    save(type){
      this.type = type
    },
    getNewsList() {
      this.$http
        .get(`/cms/blog/cms/cmsList?pageSize=5&pageNum=1`)
        .then(res => {
          if (res.code ==200) {
            this.newsList = res.rows;
            // this.total = res.data.total;

          } else {
            this.$message.warning(res.message);
          }
        });
    },
    navtonewindex(){
      this.$router.replace({
          path: `/newindex`
        });
    },
    goDetials(item) {
      console.log(item)
      if (item.newsurl){
       window.open(item.newsurl)
      }
      else {
        this.$router.replace({
          name: "newsDetials",
          params: {
            data: item
          }
        });
      }


    },
    goOther(route) {
      this.$router.replace({
        path: `/${route}`
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  body * {
    box-sizing: border-box;
    flex-shrink: 0;
  }
  body {
    font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
  }
  input {
    background-color: transparent;
    border: 0;
  }
  button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    background-color: transparent;
  }

  button:active {
    opacity: 0.6;
  }
  .van-nav-bar__left:active,
  .van-nav-bar__right:active {
    opacity: 1;
  }
  [class*='van-']::after {
    border-bottom: 0;
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  .justify-start {
    display: flex;
    justify-content: flex-start;
  }
  .justify-center {
    display: flex;
    justify-content: center;
  }

  .justify-end {
    display: flex;
    justify-content: flex-end;
  }
  .justify-evenly {
    display: flex;
    justify-content: space-evenly;
  }
  .justify-around {
    display: flex;
    justify-content: space-around;
  }
  .justify-between {
    display: flex;
    justify-content: space-between;
  }
  .align-start {
    display: flex;
    align-items: flex-start;
  }
  .align-center {
    display: flex;
    align-items: center;
  }
  .align-end {
    display: flex;
    align-items: flex-end;
  }
  .page {
    background-color: rgba(246, 249, 255, 1);
    position: relative;
    width: 100vw;
    /*height: 251.31vw;*/
    /*overflow: hidden;*/
    .group_1 {
      background-color: rgba(255, 255, 255, 1);
      width: 100vw;
      height: 3.65vw;
      justify-content: flex-center;
      .image_1 {
        width: 6.78vw;
        height: 1.88vw;
        margin: 0.88vw 0 0 21.87vw;
      }
      .text_1 {
        width: 1.46vw;
        height: 1.05vw;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 0.72vw;
        font-family: Source Han Sans CN-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 1.05vw;
        margin: 1.3vw 0 0 3.33vw;
      }
      .text_2 {
        width: 2.92vw;
        height: 1.05vw;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.72vw;
        font-family: Source Han Sans CN-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 1.05vw;
        margin: 1.3vw 0 0 1.56vw;
      }
      .thumbnail_1 {
        width: 0.63vw;
        height: 0.63vw;
        margin-top: 1.57vw;
      }
      .text_3 {
        width: 2.92vw;
        height: 1.05vw;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.72vw;
        font-family: Source Han Sans CN-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 1.05vw;
        margin: 1.3vw 0 0 1.56vw;
      }
      .text_4 {
        width: 2.92vw;
        height: 1.05vw;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.72vw;
        font-family: Source Han Sans CN-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 1.05vw;
        margin: 1.3vw 0 0 1.56vw;
      }
      .text_5 {
        width: 2.87vw;
        height: 1.05vw;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.72vw;
        font-family: Source Han Sans CN-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 1.05vw;
        margin: 1.3vw 0 0 1.56vw;
      }
      .thumbnail_2 {
        width: 0.63vw;
        height: 0.63vw;
        margin-top: 1.57vw;
      }
      .text_6 {
        width: 2.92vw;
        height: 1.05vw;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.72vw;
        font-family: Source Han Sans CN-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 1.05vw;
        margin: 1.3vw 0 0 1.56vw;
      }
      .thumbnail_3 {
        width: 0.63vw;
        height: 0.63vw;
        margin-top: 1.57vw;
      }
      .section_29 {
        width: 9.12vw;
        height: 2.35vw;
        margin: 0.62vw 21.87vw 0 11.35vw;
        .box_47 {
          width: 6.15vw;
          height: 1.2vw;
          margin-left: 2.97vw;
          .thumbnail_4 {
            width: 0.73vw;
            height: 0.73vw;
            margin-top: 0.27vw;
          }
          .text_7 {
            width: 4.95vw;
            height: 1.2vw;
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.83vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.2vw;
          }
        }
        .text_8 {
          width: 9.12vw;
          height: 0.89vw;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 0.62vw;
          font-family: Source Han Sans CN-Regular;
          font-weight: NaN;
          text-align: left;
          white-space: nowrap;
          line-height: 0.89vw;
          margin-top: 0.27vw;
        }
      }
    }
    .box_88 {
      position: relative;
      width: 100vw;
      height: 221.31vw;
      .group_43 {
        height: 25vw;
        background: url(../../assets/images/MasterDDSSlicePNG3833dcb97fea3446bfe2a2ef2fac84c7.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 100vw;
        position: relative;
        .image-wrapper_16 {
          width: 97.5vw;
          height: 1.52vw;
          margin: 12.55vw 0 0 1.77vw;
          .thumbnail_5 {
            width: 1.05vw;
            height: 0.99vw;
          }
          .thumbnail_6 {
            width: 1.05vw;
            height: 0.99vw;
            margin-top: 0.53vw;
          }
        }
        .image-wrapper_17 {
          width: 14.38vw;
          height: 0.16vw;
          margin: 9.42vw 0 1.35vw 42.03vw;
          .image_2 {
            width: 14.38vw;
            height: 0.16vw;
          }
        }
        .box_1 {
          background-color: rgba(216, 216, 216, 0);
          border-radius: 50%;
          position: absolute;
          left: 1.57vw;
          top: 11.25vw;
          width: 1.57vw;
          height: 1.57vw;
          border: 1px solid rgba(246, 249, 255, 1);
        }
        .box_2 {
          background-color: rgba(216, 216, 216, 0);
          border-radius: 50%;
          position: absolute;
          left: 98.44vw;
          top: 11.78vw;
          width: 1.57vw;
          height: 1.57vw;
          border: 1px solid rgba(246, 249, 255, 1);
        }
      }
      .group_71 {
        width: 62.4vw;
        height: 15.63vw;
        margin: 2.08vw 0 0 18.8vw;
        .group_6 {
          width: 14.07vw;
          height: 15.63vw;
          background: url(../../assets/images/MasterDDSSlicePNG9bfbbdbed7ac1a12c753ed1729376f4b.png)
          100% no-repeat;
          background-size: 100% 100%;
          .text-group_79 {
            width: 5.84vw;
            height: 2.66vw;
            margin: 2.7vw 0 0 1.45vw;
            .text_9 {
              width: 3.75vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(0, 0, 0, 1);
              font-size: 0.93vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_10 {
              width: 5.84vw;
              height: 1.05vw;
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.05vw;
              margin-top: 0.27vw;
            }
          }
          .text-wrapper_1 {
            background-color: rgba(216, 216, 216, 0);
            height: 1.46vw;
            border: 0.5px solid rgba(0, 0, 0, 1);
            width: 4.3vw;
            margin: 2.44vw 0 6.35vw 1.66vw;
            .text_11 {
              width: 3.5vw;
              margin: 0 auto;
              height: 0.89vw;
              overflow-wrap: break-word;
              color: rgba(61, 61, 61, 1);
              font-size: 0.62vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 0.89vw;
              margin: 0.26vw 0 0 0.83vw;
            }
          }
        }
        .box_49 {
          width: 27.4vw;
          height: 15.63vw;
          margin-left: 0.53vw;
          .group_8 {
            background-color: rgba(255, 255, 255, 1);
            width: 27.4vw;
            height: 7.56vw;
            .text-group_80 {
              width: 15vw;
              height: 2.92vw;
              margin: 2.44vw 0 0 1.66vw;
              .text_12 {
                width: 15vw;
                overflow: hidden;
              text-overflow: ellipsis;
                height: 1.36vw;
                overflow-wrap: break-word;
                color: rgba(61, 61, 61, 1);
                font-size: 0.83vw;
                font-family: Source Han Sans CN-Medium;
                font-weight: 500;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
              }
              .text_13 {
                width: 9.48vw;
                height: 1.36vw;
                overflow: hidden;
              text-overflow: ellipsis;
                overflow-wrap: break-word;
                color: rgba(153, 153, 153, 1);
                font-size: 0.72vw;
                font-family: Source Han Sans CN-Regular;
                font-weight: NaN;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
                margin-top: 0.21vw;
              }
            }
            .image_3 {
              width: 7.3vw;
              height: 5.47vw;
              margin: 1.04vw 1.66vw 0 0;
            }
          }
          .group_94 {
            background-color: rgba(255, 255, 255, 1);
            width: 27.4vw;
            height: 7.56vw;
            margin-top: 0.53vw;
            .text-group_81 {
              width: 8.34vw;
              height: 2.92vw;
              margin: 2.55vw 0 0 1.66vw;
              .text_14 {
                width: 8.34vw;
                height: 1.36vw;
                overflow-wrap: break-word;
                color: rgba(61, 61, 61, 1);
                font-size: 0.83vw;
                font-family: Source Han Sans CN-Medium;
                font-weight: 500;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
              }
              .text_15 {
                width: 6.57vw;
                height: 1.36vw;
                overflow-wrap: break-word;
                color: rgba(153, 153, 153, 1);
                font-size: 0.72vw;
                font-family: Source Han Sans CN-Regular;
                font-weight: NaN;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
                margin-top: 0.21vw;
              }
            }
            .image_4 {
              width: 7.3vw;
              height: 5.47vw;
              margin: 1.04vw 1.66vw 0 0;
            }
          }
        }
        .group_10 {
          background-color: rgba(255, 255, 255, 1);
          width: 19.9vw;
          height: 15.63vw;
          margin-left: 0.53vw;
          justify-content: flex-center;
          .image-text_64 {
            width: 13.03vw;
            height: 2.92vw;
            margin: 1.66vw 0 0 1.04vw;
            .text-group_82 {
              width: 10.84vw;
              height: 2.92vw;
              .text_16 {
                width: 10.84vw;
                height: 1.36vw;
                overflow: hidden;
              text-overflow: ellipsis;
                overflow-wrap: break-word;
                color: rgba(61, 61, 61, 1);
                font-size: 0.83vw;
                font-family: Source Han Sans CN-Medium;
                font-weight: 500;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
              }
              .text_17 {
                width: 6.98vw;
                height: 1.36vw;
                overflow: hidden;
              text-overflow: ellipsis;
                overflow-wrap: break-word;
                color: rgba(153, 153, 153, 1);
                font-size: 0.72vw;
                font-family: Source Han Sans CN-Regular;
                font-weight: NaN;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
                margin-top: 0.21vw;
              }
            }
            .image_5 {
              width: 1.88vw;
              height: 1.15vw;
              margin-top: 0.16vw;
            }
          }
          .text-group_83 {
            width: 17.77vw;
            height: 2.92vw;
            margin: 1.77vw 0 0 1.04vw;
            .text_18 {
              width: 17.77vw;
              height: 1.36vw;
              overflow: hidden;
              text-overflow: ellipsis;
              overflow-wrap: break-word;
              color: rgba(61, 61, 61, 1);
              font-size: 0.83vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_19 {
              width: 6.98vw;
              height: 1.36vw;
              overflow: hidden;
              text-overflow: ellipsis;
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.21vw;
            }
          }
          .text-group_84 {
            width: 9.17vw;
            height: 2.92vw;
            margin: 1.77vw 0 1.66vw 1.04vw;
            .text_20 {
              width: 9.17vw;
              height: 1.36vw;
              overflow: hidden;
              text-overflow: ellipsis;
              overflow-wrap: break-word;
              color: rgba(61, 61, 61, 1);
              font-size: 0.83vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_21 {
              width: 6.98vw;
              height: 1.36vw;
              overflow: hidden;
              text-overflow: ellipsis;
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.21vw;
            }
          }
        }
      }
      .text-group_85 {
        width: 16.78vw;
        height: 3.39vw;
        margin: 4.16vw 0 0 41.61vw;
        .text_22 {
          width: 14.9vw;
          height: 1.36vw;
          overflow-wrap: break-word;
          color: rgba(61, 61, 61, 1);
          font-size: 1.35vw;
          font-family: Source Han Sans CN-Regular;
          font-weight: NaN;
          text-align: left;
          white-space: nowrap;
          line-height: 1.36vw;
          margin-left: 0.94vw;
        }
        .text_23 {
          width: 16.78vw;
          height: 1.36vw;
          overflow-wrap: break-word;
          color: rgba(102, 102, 102, 1);
          font-size: 0.72vw;
          font-family: Source Han Sans CN-Regular;
          font-weight: NaN;
          text-align: left;
          white-space: nowrap;
          line-height: 1.36vw;
          margin-top: 0.68vw;
        }
      }
      .image_25 {
        width: 38.03vw;
        height: 38.03vw;
        margin: 4.32vw 0 0 61.45vw;
      }
      .group_72 {
        width: 29.9vw;
        height: 3.39vw;
        margin: 4.16vw 0 0 43.85vw;
        .text-group_86 {
          width: 12.4vw;
          height: 3.39vw;
          .text_24 {
            width: 8.13vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(61, 61, 61, 1);
            font-size: 1.35vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 2.09vw;
          }
          .text_25 {
            width: 12.4vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(102, 102, 102, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-top: 0.68vw;
          }
        }
        .block_1 {
          width: 15.16vw;
          height: 0.06vw;
          border: 1px solid rgba(216, 216, 216, 1);
          margin-top: 2.71vw;
        }
      }
      .group_73 {
        width: 65.11vw;
        height: 13.55vw;
        margin: 4.16vw 0 0 17.34vw;
        .box_33 {
          width: 12.61vw;
          height: 13.55vw;
          background: url(../../assets/images/MasterDDSSlicePNGc48e2751f8ab20706eadfb56ff9dd6d4.png)
          100% no-repeat;
          background-size: 100% 100%;
          .box_50 {
            width: 5vw;
            height: 1.36vw;
            margin: 1.25vw 0 0 1.92vw;
            .text_26 {
              width: 3.75vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 0.93vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .thumbnail_7 {
              width: 0.84vw;
              height: 0.84vw;
              margin-top: 0.27vw;
            }
          }
          .text_27 {
            width: 5.84vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.83vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 0.26vw 0 9.32vw 1.92vw;
          }
        }
        .box_44 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image_6 {
            width: 8.75vw;
            height: 4.9vw;
            margin: 3.12vw 0 0 1.92vw;
          }
          .text_28 {
            width: 5.11vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 2.08vw 0 0 3.75vw;
          }
          .text_29 {
            width: 7.3vw;
            height: 0.84vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            white-space: nowrap;
            line-height: 0.84vw;
            margin: 0 0 1.25vw 2.65vw;
          }
        }
        .box_55 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image_7 {
            width: 8.13vw;
            height: 5.53vw;
            margin: 2.91vw 0 0 2.23vw;
          }
          .text_30 {
            width: 5.84vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 1.66vw 0 0 3.38vw;
          }
          .text_31 {
            width: 7.24vw;
            height: 0.84vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            white-space: nowrap;
            line-height: 0.84vw;
            margin: 0 0 1.25vw 2.7vw;
          }
        }
        .box_66 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image-text_65 {
            width: 5.84vw;
            height: 10.79vw;
            margin: 0.67vw 0 0 3.38vw;
            .image_8 {
              width: 5.21vw;
              height: 8.49vw;
              margin-left: 0.32vw;
            }
            .text-group_9 {
              width: 5.84vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(0, 0, 0, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.94vw;
            }
          }
          .paragraph_1 {
            width: 7.3vw;
            height: 1.46vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            line-height: 0.73vw;
            margin: 0 0 0.62vw 2.7vw;
          }
        }
        .box_77 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image_9 {
            width: 4.74vw;
            height: 4.74vw;
            margin: 2.91vw 0 0 3.95vw;
          }
          .text_32 {
            width: 6.57vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 2.44vw 0 0 3.02vw;
          }
          .text_33 {
            width: 6.78vw;
            height: 0.84vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            white-space: nowrap;
            line-height: 0.84vw;
            margin: 0 0 1.25vw 2.91vw;
          }
        }
      }
      .group_74 {
        width: 65.11vw;
        height: 13.55vw;
        margin: 0.52vw 0 4.21vw 17.34vw;
        .block_2 {
          width: 12.61vw;
          height: 13.55vw;
          background: url(../../assets/images/MasterDDSSlicePNG8d855ebed6dd2b1be0320645909956b3.png)
          100% no-repeat;
          background-size: 100% 100%;
          .text-group_87 {
            width: 5.84vw;
            height: 2.5vw;
            margin: 0.83vw 0 0 3.38vw;
            .text_34 {
              width: 5.84vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 0.83vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_35 {
              width: 5.63vw;
              height: 0.84vw;
              overflow-wrap: break-word;
              color: rgba(194, 194, 194, 1);
              font-size: 0.62vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: center;
              white-space: nowrap;
              line-height: 0.84vw;
              margin: 0.31vw 0 0 0.1vw;
            }
          }
        }
        .block_3 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image_10 {
            width: 7.82vw;
            height: 5vw;
            margin: 2.5vw 0 0 2.39vw;
          }
          .text_36 {
            width: 6.57vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 2.6vw 0 0 3.02vw;
          }
          .text_37 {
            width: 7.82vw;
            height: 0.84vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            white-space: nowrap;
            line-height: 0.84vw;
            margin: 0 0 1.25vw 2.39vw;
          }
        }
        .block_4 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image_11 {
            width: 6.78vw;
            height: 5.94vw;
            margin: 2.13vw 0 0 2.91vw;
          }
          .text_38 {
            width: 6.57vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 2.03vw 0 0 3.02vw;
          }
          .text_39 {
            width: 10.42vw;
            height: 0.84vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            white-space: nowrap;
            line-height: 0.84vw;
            margin: 0 0 1.25vw 1.09vw;
          }
        }
        .block_5 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image_12 {
            width: 4.69vw;
            height: 5.11vw;
            margin: 2.55vw 0 0 3.95vw;
          }
          .text_40 {
            width: 5.11vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 2.44vw 0 0 3.38vw;
          }
          .text_41 {
            width: 10.68vw;
            height: 0.73vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            white-space: nowrap;
            line-height: 0.73vw;
            margin: 0 0 1.35vw 0.98vw;
          }
        }
        .block_6 {
          background-color: rgba(255, 255, 255, 1);
          width: 12.61vw;
          height: 13.55vw;
          margin-left: 0.53vw;
          .image-text_66 {
            width: 4.8vw;
            height: 10vw;
            margin: 1.45vw 0 0 3.9vw;
            .image_13 {
              width: 4.8vw;
              height: 7.61vw;
            }
            .text-group_11 {
              width: 3.65vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(0, 0, 0, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin: 1.04vw 0 0 0.57vw;
            }
          }
          .text_42 {
            width: 7.56vw;
            height: 0.84vw;
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.52vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: center;
            white-space: nowrap;
            line-height: 0.84vw;
            margin: 0 0 1.25vw 2.55vw;
          }
        }
      }
      .group_15 {
        height: 38.18vw;
        background: url(../../assets/images/MasterDDSSlicePNG88be0e64995c1a530c67c6318647734e.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 67.82vw;
        position: absolute;
        left: -1.14vw;
        top: 29.43vw;
        .group_16 {
          position: relative;
          width: 67.82vw;
          height: 38.18vw;
          background: url(../../assets/images/MasterDDSSlicePNG54eca3ad5a584bf7f7f679210ea4a435.png)
          100% no-repeat;
          background-size: 100% 100%;
          .text_43 {
            width: 10.84vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 1.35vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 8.48vw 0 0 20.05vw;
          }
          .paragraph_2 {
            width: 13.34vw;
            height: 2.71vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.83vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            line-height: 1.36vw;
            margin: 1.3vw 0 0 20vw;
          }
          .text-wrapper_2 {
            background-image: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0.5) 0,
              rgba(255, 255, 255, 0.1) 100%
            );
            border-radius: 2px;
            height: 2.61vw;
            width: 14.64vw;
            margin: 1.45vw 0 0 20.15vw;
            .text_44 {
              width: 2.82vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 0.93vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin: 0.62vw 0 0 1.3vw;
            }
          }
          .text_45 {
            width: 3.75vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.93vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 0.62vw 0 0 21.45vw;
          }
          .text_46 {
            width: 3.75vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.93vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 1.25vw 0 0 21.45vw;
          }
          .text_47 {
            width: 3.75vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.93vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 1.25vw 0 0 21.45vw;
          }
          .text_48 {
            width: 3.75vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.93vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin: 1.25vw 0 10.46vw 21.45vw;
          }
          .box_39 {
            background-image: linear-gradient(
              270deg,
              rgba(255, 255, 255, 1) 0,
              rgba(255, 255, 255, 0.509) 55.000001%
            );
            border-radius: 20px;
            position: absolute;
            left: 35.16vw;
            top: 11.62vw;
            width: 45.47vw;
            height: 16.88vw;
            .text_87 {
              width: 8.08vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(61, 61, 61, 1);
              font-size: 0.93vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin: 3.02vw 0 0 4.32vw;
            }
            .paragraph_4 {
              width: 19.69vw;
              height: 3.75vw;
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              line-height: 1.25vw;
              margin: 1.56vw 0 0 4.27vw;
            }
            .text-wrapper_59 {
              background-color: rgba(216, 216, 216, 0);
              height: 1.46vw;
              border: 1px solid rgba(40, 125, 253, 1);
              width: 5vw;
              margin: 2.34vw 0 3.38vw 4.27vw;
              .text_88 {
                width: 2.5vw;
                height: 0.89vw;
                overflow-wrap: break-word;
                color: rgba(40, 125, 253, 1);
                font-size: 0.62vw;
                font-family: Source Han Sans CN-Bold;
                font-weight: 700;
                text-align: left;
                white-space: nowrap;
                line-height: 0.89vw;
                margin: 0.26vw 0 0 0.83vw;
              }
            }
          }
        }
      }
    }
    .group_17 {
      background-color: rgba(255, 255, 255, 1);
      width: 100vw;
      height: 53.03vw;
      margin: -0.05vw 0 0 0.31vw;
      .text_51 {
        width: 5.42vw;
        height: 1.36vw;
        overflow-wrap: break-word;
        color: rgba(61, 61, 61, 1);
        font-size: 1.35vw;
        font-family: Source Han Sans CN-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 1.36vw;
        margin: 3.17vw 0 0 46.97vw;
      }
      .box_9 {
        height: 43.75vw;
        background: url(../../assets/images/MasterDDSSlicePNG94a4e443cd52dff0a2541d61343f612e.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 83.91vw;
        margin: 0.31vw 0 4.42vw 15.46vw;
        .text-wrapper_82 {
          width: 16.78vw;
          height: 1.36vw;
          margin: 0.36vw 0 0 25.83vw;
          .text_52 {
            width: 16.78vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(102, 102, 102, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
          }
        }
        .box_51 {
          width: 57.09vw;
          height: 26.2vw;
          margin: 7.81vw 0 8.02vw 6.25vw;
          .image-text_67 {
            width: 6.46vw;
            height: 8.29vw;
            margin-top: 7.66vw;
            .image_15 {
              width: 6.46vw;
              height: 6.46vw;
            }
            .text-group_12 {
              width: 4.38vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(102, 102, 102, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: center;
              white-space: nowrap;
              line-height: 1.36vw;
              margin: 0.46vw 0 0 1.04vw;
            }
          }
          .block_25 {
            width: 13.23vw;
            height: 23.39vw;
            .image-text_68 {
              width: 8.6vw;
              height: 10.32vw;
              margin-left: 4.64vw;
              .image_16 {
                width: 8.6vw;
                height: 8.6vw;
              }
              .text-group_13 {
                width: 3.65vw;
                height: 1.36vw;
                overflow-wrap: break-word;
                color: rgba(102, 102, 102, 1);
                font-size: 0.72vw;
                font-family: Source Han Sans CN-Regular;
                font-weight: NaN;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
                margin: 0.36vw 0 0 2.5vw;
              }
            }
            .image-text_69 {
              width: 8.6vw;
              height: 10.32vw;
              margin-top: 2.77vw;
              .image_17 {
                width: 8.6vw;
                height: 8.6vw;
              }
              .text-group_14 {
                width: 5.99vw;
                height: 1.36vw;
                overflow-wrap: break-word;
                color: rgba(102, 102, 102, 1);
                font-size: 0.72vw;
                font-family: Source Han Sans CN-Regular;
                font-weight: NaN;
                text-align: center;
                white-space: nowrap;
                line-height: 1.36vw;
                margin: 0.36vw 0 0 1.35vw;
              }
            }
          }
          .box_12 {
            background-color: rgba(20, 111, 249, 1);
            border-radius: 50%;
            width: 12.09vw;
            height: 12.09vw;
            margin: 6.3vw 0 0 2.55vw;
            .text_53 {
              width: 8.75vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 1.45vw;
              font-family: Source Han Sans CN-Bold;
              font-weight: 700;
              text-align: center;
              white-space: nowrap;
              line-height: 1.36vw;
              margin: 4.94vw 0 0 1.66vw;
            }
            .image-text_70 {
              width: 5.21vw;
              height: 1.36vw;
              margin: 1.04vw 0 3.38vw 3.64vw;
              .text-group_15 {
                width: 4.17vw;
                height: 1.36vw;
                overflow-wrap: break-word;
                color: rgba(255, 255, 255, 1);
                font-size: 1.04vw;
                font-family: Source Han Sans CN-Regular;
                font-weight: NaN;
                text-align: left;
                white-space: nowrap;
                line-height: 1.36vw;
              }
              .thumbnail_8 {
                width: 1.05vw;
                height: 1.05vw;
                margin-top: 0.21vw;
              }
            }
          }
          .block_26 {
            width: 19.95vw;
            height: 22.5vw;
            margin: 3.69vw 0 0 2.81vw;
            .image_18 {
              width: 7.87vw;
              height: 7.87vw;
              margin-left: 5.84vw;
            }
            .group_75 {
              width: 19.95vw;
              height: 14.43vw;
              margin-top: 0.21vw;
              .group_76 {
                width: 12.4vw;
                height: 14.22vw;
                margin-top: 0.21vw;
                .text_54 {
                  width: 5.11vw;
                  height: 1.36vw;
                  overflow-wrap: break-word;
                  color: rgba(102, 102, 102, 1);
                  font-size: 0.72vw;
                  font-family: Source Han Sans CN-Regular;
                  font-weight: NaN;
                  text-align: center;
                  white-space: nowrap;
                  line-height: 1.36vw;
                  margin-left: 7.3vw;
                }
                .image-text_71 {
                  width: 8.6vw;
                  height: 10.32vw;
                  margin-top: 2.56vw;
                  .image_19 {
                    width: 8.6vw;
                    height: 8.6vw;
                  }
                  .text-group_16 {
                    width: 5.11vw;
                    height: 1.36vw;
                    overflow-wrap: break-word;
                    color: rgba(102, 102, 102, 1);
                    font-size: 0.72vw;
                    font-family: Source Han Sans CN-Regular;
                    font-weight: NaN;
                    text-align: center;
                    white-space: nowrap;
                    line-height: 1.36vw;
                    margin: 0.36vw 0 0 1.77vw;
                  }
                }
              }
              .group_77 {
                width: 6.46vw;
                height: 8.29vw;
                .image_20 {
                  width: 6.46vw;
                  height: 6.46vw;
                }
                .text_55 {
                  width: 2.92vw;
                  height: 1.36vw;
                  overflow-wrap: break-word;
                  color: rgba(102, 102, 102, 1);
                  font-size: 0.72vw;
                  font-family: Source Han Sans CN-Regular;
                  font-weight: NaN;
                  text-align: center;
                  white-space: nowrap;
                  line-height: 1.36vw;
                  margin: 0.46vw 0 0 1.87vw;
                }
              }
            }
          }
        }
      }
    }
    .box_52 {
      position: relative;
      width: 100vw;
      height: 47.77vw;
      .box_14 {
        height: 21.62vw;
        background: url(../../assets/images/MasterDDSSlicePNGe933af5e0d5c13601512fcbd7ee3fccb.png)
        100% no-repeat;
        background-size: 100% 100%;
        margin-top: 0.06vw;
        width: 100vw;
        .section_30 {
          width: 16.78vw;
          height: 3.39vw;
          margin: 4.06vw 0 0 41.61vw;
          .text-group_88 {
            width: 16.78vw;
            height: 3.39vw;
            .text_56 {
              width: 5.42vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 1.35vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-left: 5.68vw;
            }
            .text_57 {
              width: 16.78vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(209, 209, 209, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Regular;
              font-weight: NaN;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.68vw;
            }
          }
        }
        .text-wrapper_83 {
          width: 55.79vw;
          height: 1.36vw;
          margin: 4.68vw 0 0 22.13vw;
          .text_58 {
            width: 6.67vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 1.66vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
          }
          .text_59 {
            width: 6.67vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 1.66vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 8.6vw;
          }
          .text_60 {
            width: 6.67vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 1.66vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 8.6vw;
          }
          .text_61 {
            width: 10vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 1.66vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 8.6vw;
          }
        }
        .text-wrapper_84 {
          width: 48.29vw;
          height: 1.36vw;
          margin: 2.29vw 0 4.47vw 22.13vw;
          .text_62 {
            width: 3.7vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 2.08vw;
            font-family: Source Han Sans CN-Bold;
            font-weight: 700;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
          }
          .text_63 {
            width: 2.5vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 2.08vw;
            font-family: Source Han Sans CN-Bold;
            font-weight: 700;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 11.57vw;
          }
          .text_64 {
            width: 2.5vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 2.08vw;
            font-family: Source Han Sans CN-Bold;
            font-weight: 700;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 12.77vw;
          }
          .text_65 {
            width: 2.5vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 2.08vw;
            font-family: Source Han Sans CN-Bold;
            font-weight: 700;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 12.77vw;
          }
        }
      }
      .image-wrapper_3 {
        background-color: rgba(255, 255, 255, 1);
        height: 26.1vw;
        width: 100vw;
        position: absolute;
        left: 0;
        top: 21.62vw;
        .image_22 {
          width: 58.49vw;
          height: 20.79vw;
          margin: 4.16vw 0 0 20.78vw;
        }
      }
    }
    .image_21 {
      height: 20.84vw;
      background: url(../../assets/images/MasterDDSSlicePNG060a13daa63d654af566319f44f769b0.png)
      100% no-repeat;
      background-size: 100% 100%;
      margin-top: -0.05vw;
      width: 100vw;
      .group_21 {
        background-color: rgba(1, 23, 76, 0.8);
        height: 20.84vw;
        width: 100vw;
        .box_53 {
          width: 56.88vw;
          height: 3.23vw;
          margin: 3.59vw 0 0 22.13vw;
          .image_23 {
            width: 8.7vw;
            height: 2.4vw;
          }
          .text-wrapper_85 {
            width: 3.34vw;
            height: 3.23vw;
            margin-left: 7.04vw;
            .text_66 {
              width: 3.34vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 0.83vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_67 {
              width: 2.92vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.53vw;
            }
          }
          .text-wrapper_86 {
            width: 3.34vw;
            height: 3.23vw;
            margin-left: 8.08vw;
            .text_68 {
              width: 3.34vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 0.83vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_69 {
              width: 2.19vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.53vw;
            }
          }
          .text-wrapper_87 {
            width: 3.29vw;
            height: 3.23vw;
            margin-left: 7.04vw;
            .text_70 {
              width: 3.29vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 0.83vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_71 {
              width: 2.87vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.53vw;
            }
          }
          .text-wrapper_88 {
            width: 8.49vw;
            height: 3.23vw;
            margin-left: 7.61vw;
            .text_72 {
              width: 3.34vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 0.83vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_73 {
              width: 8.49vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.53vw;
            }
          }
        }
        .text-wrapper_89 {
          width: 41.62vw;
          height: 1.36vw;
          margin: 0.52vw 0 0 37.86vw;
          .text_74 {
            width: 2.92vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
          }
          .text_75 {
            width: 2.92vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 8.49vw;
          }
          .text_76 {
            width: 2.87vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 7.45vw;
          }
          .text_77 {
            width: 8.96vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 8.03vw;
          }
        }
        .text-wrapper_90 {
          width: 39.69vw;
          height: 1.36vw;
          margin: 0.52vw 0 0 37.86vw;
          .text_78 {
            width: 2.92vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
          }
          .text_79 {
            width: 2.92vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 8.49vw;
          }
          .text_80 {
            width: 4.12vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 7.45vw;
          }
          .text_81 {
            width: 7.04vw;
            height: 1.36vw;
            overflow-wrap: break-word;
            color: rgba(217, 217, 217, 1);
            font-size: 0.72vw;
            font-family: Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 1.36vw;
            margin-left: 6.78vw;
          }
        }
        .box_54 {
          width: 37.56vw;
          height: 6.05vw;
          margin: 0.52vw 0 3.69vw 37.86vw;
          .text-wrapper_91 {
            width: 4.38vw;
            height: 5.11vw;
            .text_82 {
              width: 2.92vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_83 {
              width: 2.92vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.53vw;
            }
            .text_84 {
              width: 4.38vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.53vw;
            }
          }
          .text-wrapper_92 {
            width: 2.92vw;
            height: 3.23vw;
            margin-left: 7.04vw;
            .text_85 {
              width: 2.92vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
            }
            .text_86 {
              width: 2.92vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-top: 0.53vw;
            }
          }
          .image-text_72 {
            width: 4.69vw;
            height: 6.05vw;
            margin-left: 18.55vw;
            .image_24 {
              width: 4.69vw;
              height: 4.69vw;
            }
            .text-group_18 {
              width: 3.65vw;
              height: 1.36vw;
              overflow-wrap: break-word;
              color: rgba(217, 217, 217, 1);
              font-size: 0.72vw;
              font-family: Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 1.36vw;
              margin-left: 0.53vw;
            }
          }
        }
      }
    }
  }

  #home {
  width: 100%;
  height: 100%;
  .swiperBox {
    width: 100%;
    height: 480px;
    .swiper-container {
      height: 100%;
      .swiperImage {
        width: 100%;
        height: 100%;
      }
      .banner1 {
        background: #05112b url("../../assets/images/home/banner1.png")
          no-repeat center center;
        background-size: auto 100%;
      }
      .banner2 {
        background: #05102e url("../../assets/images/home/banner2.png")
          no-repeat center center;
        background-size: auto 100%;
      }
      .banner3 {
        background: #010238 url("../../assets/images/home/banner3.png")
          no-repeat center center;
        background-size: auto 100%;
      }
      .iconfont {
        position: absolute;
        font-size: 45px;
        z-index: 11;
        top: calc(50% - 20px);
        cursor: pointer;
        color: #bbbaba;
      }
      .iconfont:hover {
        color: #068efb;
        font-size: 47px;
        top: calc(50% - 21px);
      }
      .icon-zuo-yuan {
        left: 10px;
      }
      .icon-you-yuan {
        right: 10px;
      }
    }
  }

  /*物联网*/
  .contentUnionMain {
    width: 100%;
    margin-bottom: 30px;
    .terminalContentBox {
      max-width: 1200px;
      height: 100%;
      margin: 0 auto;
      .terminalContent {
        margin-top: 5px;
        margin-bottom: 5px;
        height: 315px;
        background: #f3f3f3;
        padding: 0 52px;
        box-sizing: border-box;
        .title {
          font-size: 22px;
          color: #000;
          line-height: 42px;
          text-align: right;
        }
        .text {
          font-size: 10px;
          color: #999;
          line-height: 16px;
        }
        .imageTitle {
          font-size: 12px;
          color: #999;
          height: 14px;
          overflow: hidden;
          .icons {
            width: 5px;
            height: 5px;
            float: left;
            background: #999;
            margin: 6px;
            margin-left: 0;
          }
          .imageText {
            float: left;
          }
        }
      }
      .mainframe {
        margin-left: 0;
        height: 575px;
        background: #e7ebee;
        padding: 0 24px;
        .title {
          line-height: 94px;
          padding-top: 0;
          text-align: left;
        }
      }
    }
  }
  /*案例*/
  .case {
    width: 100%;
    height: auto;
    overflow: hidden;
    background: #f4f5f7;
    .commonTop .titleTop {
      width: 800px;
    }
    .lookMore {
      width: 100%;
      font-size: 16px;
      color: #068efb;
      text-align: center;
      padding-bottom: 30px;
      cursor: pointer;
    }
    .caseBox {
      height: 300px;
      margin: 0 auto;
      overflow-x: auto;
      width: 100%;
      ul {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        li {
          width: 180px;
          height: 250px;
          margin: 0 10px;
          border-radius: 10px;
          transition: all 0.3s;
          overflow: hidden;
          .imgBox {
            width: 160px;
            height: 160px;
            margin: 0 auto;
            border-radius: 50%;
            overflow: hidden;
            border: 1px solid transparent;
            img {
              width: 100%;
              height: 160px;
              border-radius: 50%;
              transition: all 0.3s;
            }
          }
          .title {
            color: #333;
            font-size: 16px;
            line-height: 80px;
            text-align: center;
          }
        }
        li:hover {
          .imgBox {
            border-color: #068efb;
            img {
              transform: scale(1.3, 1.3);
            }
          }
        }
      }
    }
  }

  /*证书*/
  .certificate {
    width: 100%;
    height: 700px;
    overflow: hidden;
    background: #fff;
    padding-bottom: 50px;
    .commonTop .titleTop {
      width: 830px;
    }
    .lookMore {
      width: 100%;
      font-size: 16px;
      color: #068efb;
      text-align: center;
      padding-bottom: 30px;
      cursor: pointer;
    }
    .certificateBox {
      max-width: 1200px;
      width: 100%;
      height: 400px;
      .swiper-container {
        height: 100%;
        .swiperImage {
          width: 100%;
          height: 100%;
          .slideTop {
            width: 100%;
            height: 310px;
            background: #b6956c; /* Old browsers */
            background: -moz-linear-gradient(
              45deg,
              #b6956c 0%,
              #eaded0 42%,
              #ece2d6 50%,
              #eaded0 58%,
              #b6956c 100%
            ); /* FF3.6-15 */
            background: -webkit-linear-gradient(
              45deg,
              #b6956c 0%,
              #eaded0 42%,
              #ece2d6 50%,
              #eaded0 58%,
              #b6956c 100%
            ); /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(
              45deg,
              #b6956c 0%,
              #eaded0 42%,
              #ece2d6 50%,
              #eaded0 58%,
              #b6956c 100%
            ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b6956c', endColorstr='#b6956c',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
            .flt {
              width: 50%;
              height: 100%;
            }
            .frt {
              width: 50%;
              height: 100%;
              .text {
                font-size: 20px !important;
                height: 20px;
                padding-top: 100px !important;
                line-height: 20px !important;
                text-align: left !important;
                color: #594210 !important;
              }
              div {
                font-size: 36px;
                line-height: 80px;
                color: #594210;
              }
              @media (max-width: 520px) {
                .text {
                  font-size: 16px !important;
                }
                div {
                  font-size: 25px !important;
                }
              }
            }
            .imgBox {
              width: 100%;
              height: 100%;
            }
            .certificate1 {
              background: url("../../assets/images/certificate/certificate2.jpg")
                no-repeat center center;
              background-size: 170px auto;
            }
            .certificate2 {
              background: url("../../assets/images/certificate/certificate4.jpg")
                no-repeat center center;
              background-size: 170px auto;
            }
            .certificate3 {
              background: url("../../assets/images/certificate/certificate5.jpg")
                no-repeat center center;
              background-size: 170px auto;
            }
            .certificate4 {
              background: url("../../assets/images/certificate/certificate7.jpg")
                no-repeat center center;
              background-size: 170px auto;
            }
            .certificate5 {
              background: url("../../assets/images/certificate/certificate10.jpg")
                no-repeat center center;
              background-size: 170px auto;
            }
            .certificate6 {
              background: url("../../assets/images/certificate/certificate23.jpg")
                no-repeat center center;
              background-size: 170px auto;
            }
          }
          .slideTitle {
            width: 100%;
            height: calc(100% - 310px);
            text-align: center;
            line-height: 98px;
            font-size: 16px;
            color: #666;
          }
        }
        .iconfont {
          position: absolute;
          font-size: 45px;
          z-index: 11;
          top: calc(50% - 20px);
          cursor: pointer;
          color: #bbbaba;
        }
        .iconfont:hover {
          color: #068efb;
          font-size: 47px;
          top: calc(50% - 21px);
        }
        .icon-zuo-yuan {
          left: 10px;
        }
        .icon-you-yuan {
          right: 10px;
        }
      }
    }
    #certify {
      position: relative;
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
    }

    #certify .swiper-container {
      padding-bottom: 60px;
    }

    #certify .swiper-slide {
      max-width: 520px;
      width: 100%;
      height: 408px;
      background: #fff;
      box-shadow: 0 8px 30px #ddd;
    }
    #certify .swiper-slide img {
      display: block;
    }
    #certify .swiper-slide p {
      line-height: 98px;
      padding-top: 0;
      text-align: center;
      color: #636363;
      font-size: 1.1em;
      margin: 0;
    }

    #certify .swiper-pagination {
      width: 100%;
      bottom: 0px;
    }

    #certify .swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 0 5px;
      border: 3px solid #fff;
      background-color: #d5d5d5;
      width: 10px;
      height: 10px;
      opacity: 1;
    }

    #certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
      border: 3px solid #00aadc;
      background-color: #fff;
    }

    #certify .swiper-button-prev {
      left: -30px;
      width: 45px;
      height: 45px;
      // background: url(../images/wm_button_icon.png) no-repeat;
      background-position: 0 0;
      background-size: 100%;
    }

    #certify .swiper-button-prev:hover {
      background-position: 0 -46px;
      background-size: 100%;
    }

    #certify .swiper-button-next {
      right: -30px;
      width: 45px;
      height: 45px;
      // background: url(../images/wm_button_icon.png) no-repeat;
      background-position: 0 -93px;
      background-size: 100%;
    }

    #certify .swiper-button-next:hover {
      background-position: 0 -139px;
      background-size: 100%;
    }
  }

  /*公用top*/
  .commonTop {
    width: 100%;
    // height: 190px;
    padding: 70px 0 40px;
    box-sizing: border-box;
    .titleTop {
      width: 73% !important;
      height: 45px;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        width: 235px;
        height: 1px;
        background: #d2d2d2;
        margin: 22px;
      }
      .title {
        font-size: 26px;
        color: #282828;
        line-height: 45px;
        span {
          color: #005aab;
          font-size: 26px;
        }
      }

      @media (max-width: 1200px) {
        .title {
          font-size: 20px;
          span {
            font-size: 20px;
          }
        }
        p {
          display: none;
        }
      }
      @media (max-width: 768px) {
        .title {
          font-size: 18px;
          span {
            font-size: 18px;
          }
        }
        p {
          display: none;
        }
      }
    }
    .explain {
      text-align: center;
      font-size: 14px;
      line-height: 30px;
    }
  }

  /*媒体查询*/
  @media screen and (max-width: 768px) {
    .swiperBox {
      height: 240px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mains/home.vue